// ─── Las fechas del calendario del portal (M4·B1) ───────────────────────────
// Las fechas de una clase o una sesión son DÍAS DE CALENDARIO del seminario
// («2026-10-22»), no instantes. Antes, con el aula encendida, el portal las leía
// con `new Date('2026-10-22')` —medianoche UTC— y pedía la ventana con
// `toISOString()` —el día de UTC—: al oeste de UTC (Los Ángeles, Chile) la clase
// aparecía el día anterior, y desde la tarde «hoy» ya era mañana. Sin aula (g4)
// ya se leían así; ahora vale para las dos fuentes.

/** El día de calendario de `d` en la zona del navegador (no el de UTC). */
export function localYmd(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/** Un día «YYYY-MM-DD» como Date a mediodía local: ninguna zona lo corre de día. */
export function calendarDay(ymd: string): Date {
  return new Date(`${ymd.slice(0, 10)}T12:00:00`);
}
